/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import AbstractModule from "../abstract_module";
import IEffectModule from "./scene_effect_interface";
import {RenderDocument} from "js_renderer";
import {vec2} from "gl-matrix";
import Scene from "../../scene";
import Settings from "../settings";

interface IEffectsSettings {
    raining?: boolean;
    snowing?: boolean;
    maze?: boolean;
}

export default
class EffectsModule extends AbstractModule implements IEffectModule {

    protected static _typeName: string = "effects";

    protected _defaultSettings: IEffectsSettings;
    protected _settings: IEffectsSettings;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);

        this._type = EffectsModule._typeName;

        this._defaultSettings = {
            snowing: false,
            raining: false,
            maze: false
        };

        this._settings = Settings.clone(this._defaultSettings);
    }

    public static getClassType(): string {
        return EffectsModule._typeName;
    }

    public viewChanged() {
        //
    }

    public viewResized(aContentSize: vec2) {
        //
    }

    public setFromModelDescription(aJsonObject: any) {
        let settings: IEffectsSettings = {};
        if (aJsonObject.hasOwnProperty(EffectsModule._typeName)) {
            settings = aJsonObject[EffectsModule._typeName];
        }
        this.set(settings);
    }

    protected applySettings(aChangedSettings: any, aPreviousSettings: any) {
        //
    }
}

Scene.registerSceneAPIModule(EffectsModule);
